module.exports = __webpack_public_path__ + "img/prod_info_pdjhxt.4963223c.png";